import { jsx as _jsx } from "react/jsx-runtime";
import { useAppContext, screenBreakpoints } from 'App/app-context';
import { Tooltip, Button } from 'antd';
import { txt } from 'libs/i18n';
import { KeyIcon } from 'components/CustomIcons';
import styles from './style.module.less';
const KeywordButton = ({ onShowKeywords, showKeywords }) => {
    const { screenSize } = useAppContext();
    const showLabel = screenSize.width >= screenBreakpoints.sm;
    return (_jsx(Tooltip, { title: showKeywords ? txt('hideKeywords') : txt('showKeywordsAvailable'), placement: "topLeft", children: _jsx("div", { children: _jsx(Button, { className: showKeywords ? styles.keywordsOnButton : styles.keywordsOffButton, size: "small", onClick: onShowKeywords, icon: _jsx(KeyIcon, { className: styles.keyIcon }), children: showLabel && (_jsx("span", { className: styles.keyButtonText, children: txt('keywords') })) }) }) }));
};
export default KeywordButton;
